<template>
  <div class="box_div" :style="{ paddingBottom: imgHeight - 20 + 'px' }">
    <header class="header">
      <!-- <img class="top_image" ref="topImageRef" @click="goBlogpage"  src="../../assets/images/top_image.jpg" alt=""> -->
      <div class="ip_judgment" v-if="showTopIP">检测到您当前所在地区为海外，建议访问海外版网站以获得更佳体验。
        <el-button type="info" size="small" @click="switchFun" style="">{{ ipOperationData == 'switch' ?
          `${countdown}秒后自动跳转到海外站` : '切换到海外站' }}</el-button>
        <el-button type="info" class="w_btn" size="small" @click="continueFun" style="width: 120px;">{{ ipOperationData
          == 'switch' ? '停留在当前网站' : '继续访问' }}</el-button>
      </div>
      <!-- <svgList /> -->
      <div class="section">
        <h1 class="font-size-0 flex items-center">
          <router-link :to="{ name: 'home' }">
            <el-popover v-if="platForm == 'Mac'" popper-class="popoverStyles" placement="bottom" width="280"
              :visible-arrow="false" trigger="hover" content="按「⌘+D」收藏本站 或 拖动LOGO到书签栏">
              <img class="logo" alt="ChatExcel" slot="reference" src="../../assets/images/logo.png" />
            </el-popover>
            <el-popover v-else placement="bottom" width="300" :visible-arrow="false" trigger="hover"
              content="按「Ctrl+D」收藏本站 或 拖动LOGO到书签栏">
              <img class="logo" alt="ChatExcel" slot="reference" src="../../assets/images/logo.png" />
            </el-popover>
            <!-- <img class="logo" alt="ChatExcel" src="../../assets/images/logo.png" />ChatExcel -->
          </router-link>
          <!-- <span class="beta-version">Beta</span> -->
        </h1>

        <nav class="nav-menu">
          <div class="nav-menu-item" v-show="false">
            <div class="nav-menu-item-inner">
              <!-- <router-link :to="{ name: 'home' }"> 产品 </router-link> -->
              <a href="javascript:;">
                {{ $t(`header_config.product.title`) }}</a>
              <svg class="iconpark-icon iconpark-down">
                <use href="#c-down"></use>
              </svg>
              <div class="nav-sub-menu-container">
                <div class="sub-menu-wrapper">
                  <div class="sub-menu-item-box" @click="godetail(1)">
                    <div>
                      <h5 class="sub-menu-title">
                        {{ $t(`header_config.product.content[0].card_tit`) }}
                      </h5>
                      <p class="sub-menu-desc">
                        {{ $t(`header_config.product.content[0].card_cont`) }}
                      </p>
                    </div>
                  </div>
                  <!-- <div class="sub-menu-item-box" @click="godetail(2)">
                    <div>
                      <h5 class="sub-menu-title">{{$t(`header_config.product.content[1].card_tit`)}}</h5>
                      <p class="sub-menu-desc">
                        {{$t(`header_config.product.content[1].card_cont`)}}
                      </p>
                    </div>
                  </div>  -->
                  <!-- <div class="sub-menu-item-box" @click="godetail(4)">
                    <div>
                      <h5 class="sub-menu-title">AI 营销辅助决策</h5>
                      <p class="sub-menu-desc">
                        借助AI挖掘数据，对话式获取产品/消费者/市场洞察
                      </p>
                    </div>
                  </div> -->
                  <!-- <div class="sub-menu-item-box" @click="godetail(3)">
                    <div>
                      <h5 class="sub-menu-title">{{$t(`header_config.product.content[2].card_tit`)}}</h5>
                      <p class="sub-menu-desc">
                        {{$t(`header_config.product.content[2].card_cont`)}}
                      </p>
                    </div>
                  </div> -->

                  <!-- <router-link class="sub-menu-item-box" :to="{ name: 'popularFeelings' }">
                  <img src="@/assets/images/navigation04.png" alt="" style="width: 16px; height: 16px;margin-top: 5px;" />

                  <div>
                    <h5 class="sub-menu-title">AIGA辅助决策</h5>
                    <p class="sub-menu-desc">
                      后链路数据对接,与电商订单数据整合，形成决策闭环
                    </p>
                  </div>
                </router-link> -->
                </div>
              </div>
            </div>
          </div>
          <div class="nav-menu-item">
            <div class="nav-menu-item-inner">
              <el-dropdown placement="bottom" trigger="click">
                <div class="nav-menu-item-inner">
                  <a>元空AI Work <i class="el-icon-arrow-down el-icon--right"></i></a>
                </div>
                <template #dropdown>
                  <el-dropdown-menu>
                    <el-dropdown-item><a href="aiMax">AI Excel Max</a></el-dropdown-item>
                    <el-dropdown-item><a href="aiPPT" @click.stop>AI PPT</a></el-dropdown-item>
                    <el-dropdown-item><a href="aiReport" @click.stop>AI Word</a></el-dropdown-item>
                    <!-- <el-dropdown-item><a href="claw">AI Claw</a></el-dropdown-item> -->
                    <!-- <el-dropdown-item><a href="/aipcPage" @click.stop>AI PC客户端</a></el-dropdown-item> -->
                    <!-- <el-dropdown-item @click.native="openByParent"><a target="_blank"
                        href="https://chatexcel.com/blog/tob/" @click.stop>团队企业版</a></el-dropdown-item> -->
                    <el-dropdown-item><a href="yuanYuan" @click.stop>AI 桌宠</a></el-dropdown-item>
                    <!-- <el-dropdown-item><a href="/aippt_lesson">AI 教案</a></el-dropdown-item> -->
                    <!-- <el-dropdown-item><a href="/ai_table">AI 做表</a></el-dropdown-item> -->


                    <!-- <el-dropdown-item @click.native="openByParent"><a target="_blank"
                        href="https://chatexcel.com/blog/tob/" @click.stop>本地部署版</a></el-dropdown-item> -->
                  </el-dropdown-menu>
                </template>
              </el-dropdown>
            </div>
          </div>
     
           <!-- <div class="nav-menu-item">
            <div class="nav-menu-item-inner">

          <el-dropdown placement="bottom" trigger="click">
            <div class="nav-menu-item-inner">
              <a>关于我们 <i class="el-icon-arrow-down el-icon--right"></i></a>
            </div>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item><a href="/aboutUs" @click.stop>公司介绍 </a></el-dropdown-item>
                <el-dropdown-item> <a @click="goBlog">新闻资讯</a></el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
          </div>
          </div> -->
            <div class="nav-menu-item" >
            <div class="nav-menu-item-inner">
              <a target="_blank" href="https://www.e2sci.com/">元空AI Science</a>
            </div>
          </div>
          <div class="nav-menu-item">
            <div class="nav-menu-item-inner">
              <a  href="enterprise" @click.stop>企业版</a>
            </div>
          </div>
             <div class="nav-menu-item">
            <div class="nav-menu-item-inner">
              <a target="_blank" rel="noopener noreferrer" href="https://www.yuankongai.com/pages/AIStation" @click.stop>AI Station</a>
            </div>
          </div>
          <div class="nav-menu-item">
            <div class="nav-menu-item-inner" @click="openByParent">
              <a target="_blank" href="https://chatexcel.com/blog/security/" @click.stop>数据安全</a>
            </div>
          </div>
          <!-- <div class="nav-menu-item">
            <div class="nav-menu-item-inner">
              <a @click="goOpen">开放平台 </a>
            </div>
          </div> -->
               <div class="nav-menu-item">
            <div class="nav-menu-item-inner">
              <!-- @click="waitClick" -->
              <a  target="_blank" href="https://chatexcel.com/blog/tutorial/">免费教程</a>
            </div>
          </div>
          <div class="nav-menu-item" v-if="getCooperativeInfos.download_client_entrance_state != 2">
            <div class="nav-menu-item-inner">
              <a  href="downloadClient">下载客户端</a>
            </div>
          </div>
         
          <!-- <div class="nav-menu-item">
            <div class="nav-menu-item-inner">
              <a @click="equityComparisonPage">权益对比 </a>
            </div>
          </div> -->
        </nav>
        <div class="header-right">
          <!-- <div class="gift_div" @click="goGiftPage" v-if="!getCooperativeInfos.is_cooperative">
            <img class="gift_img" alt="liwu" src="../../assets/images/gift.png" />
            <span>邀好友赚套餐</span>
          </div> -->
          <!-- <el-popover placement="left-start" style="height: 100px" width="180" trigger="hover"
            popper-class="popoverStyle" :visible-arrow="false" v-model="visible">
            <div class="float_box" @click="goGiftPage">
              <img class="float_bg" alt="liwu" src="../../assets/images/gift_bg.png" />
            </div>
            <div class="float_div" slot="reference" v-if="!getCooperativeInfos.is_cooperative">
              <div class="float_img_div">
                <img class="float_img" alt="liwu" src="../../assets/images/gift_right.png" />
              </div>
            </div>
          </el-popover> -->
          <el-popover placement="left-start" style="height: 100px" width="180" trigger="hover"
            popper-class="popoverStyle">
            <div class="float_box">
              <img class="float_bg" alt="liwu" src="../../assets/images/qrcode_.png" />
              <!-- <span>邀好友 赚套餐</span> -->
            </div>
            <div class="float_div code_div" slot="reference" v-if="!getCooperativeInfos.is_cooperative">
              <div class="float_img_div">
                <img class="float_img" alt="liwu" src="../../assets/images/code_img.png" />
              </div>
            </div>
          </el-popover>
          <!-- <el-dropdown @command="handleCommand">
            <span class="el-dropdown-link" style="margin-right: 20px;">
              {{ { zh_CN: '中文', en_US: 'English', ja_US: '日本語' }[$store.state.language] }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="zh_CN">中文</el-dropdown-item>
              <el-dropdown-item command="en_US">English</el-dropdown-item>
              <el-dropdown-item command="ja_US">日本語</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown> -->
          <!-- {{$t(`global.contactUs`)}} -->
          <button v-if="!$store.state.login_token" @click="loginChange" class="login-btn">
            {{ $t(`global.login_btn`) }}
          </button>
          <div v-else class="user-info">
            <button class="get-started-btn" @click="$toUse()" size="small">
              {{ $t(`global.enter_btn`) }}
            </button>
            <div class="user-card">
              <img v-if="userInfo.is_vip" src="../../assets/images/vip_border.svg" class="header_border" alt="" />
              <img :src="userInfo.head_image
                ? userInfo.head_image
                : require('../../assets/images/head.png')
                " alt="" class="user-avatar" style="border-radius: 50%" />
              <span class="account">
                <el-popover placement="bottom" width="240" trigger="click" :content="userInfo.name">
                  <span slot="reference">
                    {{ userInfo.name }}
                  </span>
                </el-popover>
              </span>

              <!-- <span class="account">
                {{ userInfo.name }}
              </span> -->

              <svg class="iconpark-icon">
                <use href="#c-sanjiao-xia"></use>
              </svg>
              <div class="log-out-box" v-if="getCooperativeInfos.log_out_show_state != 2">
                <div class="log-out">
                  <span id="loginOut" @click="logOuts">
                    {{ $t(`global.outLog_btn`) }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  </div>
</template>

<script>
import svgList from "@/components/svgList";
import { clearCookies, getCookie, setCookie } from "@/utils/cookie";
import { logOut, effectiveMeal, cooperativeInfo, isChinaIpv4 } from "@/api/user.js";
import zhCN from "../../i18n/lang/zh-CN";
import enUS from "../../i18n/lang/en";
import { domainName } from "@/utils/domainName";

export default {
  name: "navHeader",
  components: { svgList },
  data() {
    return {
      language: this.$store.state.language, //多语言
      visible: false,
      platForm: "",
      userInfo: getCookie("userInfo") ? JSON.parse(getCookie("userInfo")) : "",
      getCooperativeInfos: JSON.parse(getCookie("cooperativeInfos"))
        ? JSON.parse(getCookie("cooperativeInfos"))
        : { is_cooperative: false },
      imgHeight: 0, // 初始化图片高度为0
      showTopIP: false,
      ipOperationData: getCookie('ipOperation'),
      countdown: 0, // 倒计时秒数
      countdownTimer: null // 定时器引用
    };
  },
  computed: {
    setUserInfo() {
      return this.$store.state.userInfo;
    },
  },
  watch: {
    setUserInfo: function (data) {
      this.userInfo = JSON.parse(data);
    },
  },
  mounted() {
    // this.getImageHeight()
    if (!getCookie("language")) {
      this.$store.commit("setLanguage", "zh_CN");
      // location.reload()
    }
    this.platForm = this.getOperatingSystem();

    if (
      this.$route.query.partner_uuid ||
      sessionStorage.getItem("queryParams")
    ) {
      this.getCooperativeInfo();
    }

    isChinaIpv4({
      access_token: getCookie("access_token"),
    }).then((res) => {
      if (res.data.code === 0) {
        this.showTopIP = res.data.data.is_china ? false : getCookie('ipOperation') == 'continue' ? false : true
        if (getCookie('ipOperation') == 'switch') {
          this.timerFun()
        }
      } else {
        Message.error(res.data.msg);
      }
    });

    //
  },
  methods: {
    continueFun() {
      setCookie("ipOperation", 'continue');
      this.showTopIP = false
      this.countdown = 0;
      clearInterval(this.countdownTimer);
    },
    switchFun() {
      setCookie("ipOperation", 'switch');
      window.location.replace(domainName.api13);
      this.showTopIP = false
    },
    timerFun() {
      if (this.countdown > 0 || !this.showTopIP) return; // 防止重复点击

      this.countdown = 10;
      this.countdownTimer = setInterval(() => {
        this.countdown--;
        if (this.countdown == 0) {
          clearInterval(this.countdownTimer);
          // 执行跳转逻辑，例如：
          window.location.replace(domainName.api13);
          // 或者调用其他跳转方法
        }
      }, 1000);
    },
    getImageHeight() {
      const imgElement = this.$refs.topImageRef;

      if (imgElement && imgElement.complete) {
        // 如果图片已经加载完毕，则直接获取高度
        this.imgHeight = imgElement.offsetHeight;
      } else {
        // 如果图片尚未加载完毕，则添加一个onload事件监听器
        imgElement.onload = () => {
          this.imgHeight = imgElement.offsetHeight;
        };
      }
    },
    // 父级点击，自动查找子级 a[href]，新标签打开
    openByParent(e) {
      const anchor = e.currentTarget && e.currentTarget.querySelector
        ? e.currentTarget.querySelector('a[href]')
        : null;
      if (!anchor) return;
      const href = anchor.getAttribute('href');
      const text = (anchor.textContent || '').trim();
      // ChatExcel 不新开标签
      if (text === 'ChatExcel' || href === '/') return;
      if (!href || href === '#' || href.startsWith('javascript:')) return;
      window.open(href, '_blank');
    },
    handleMenu(menu) {
      console.log(menu);
      if (menu == 1) {
        this.goBlog();
      } else if (menu == 2) {
        this.goTeaching();
      } else if (menu == 3) {
        this.goIntroduce();
      }
    },
    // 即将上线
    waitClick() {
      this.clicktutorialPage();
    },
    getCooperativeInfo() {
      cooperativeInfo({
        access_token: getCookie("access_token"),
      }).then((res) => {
        if (res.data.code === 0) {
          let datas = res.data.data;
          datas.is_cooperative = true;
          datas.time = new Date().valueOf();
          setCookie("cooperativeInfos", JSON.stringify(res.data.data));
          this.getCooperativeInfos = JSON.parse(getCookie("cooperativeInfos"));
        } else {
          Message.error(res.data.msg);
        }
      });
    },
    // 下载客户端
    clickDownload() {
      this.$router.push({
        name: "downloadClient",
      });
    },
    // 判断win or mac
    getOperatingSystem() {
      const platform = navigator.platform.toLowerCase();
      if (platform.includes("mac")) return "Mac";
      if (platform.includes("win")) return "Windows";
      return "Unknown";
    },
    // 语言切换
    handleCommand(command) {
      this.language = command;
      this.$i18n.locale = command; // 设置给本地的i18n插件
      this.$store.commit("setLanguage", this.language);
      this.$message({
        showClose: true,
        type: "success",
        message:
          (command == "zh_CN"
            ? "切换语言成功"
            : "Successfully switched languages") + command,
        duration: 1000,
        center: true,
      });
      location.reload();
      // this.$message.success('切换语言成功' + command)
    },
    // 点击使用教程
    clicktutorialPage() {
      // if (getCookie("access_token")) {
      window.open(`https://chatexcel.com/blog/tutorial/`, "_blank");
      // this.$router.push({
      //   name: 'tutorialPage',
      // })
      // }
    },
    godetail(type) {
      if (getCookie("access_token")) {
        if (!getCookie("login_token")) {
          this.$store.commit("setLoginDisplay", true);
          return;
        }
        if (type == 1) {
          location.href = domainName.api1;
        } else if (type == 2) {
          // this.$router.push({
          //   name: 'illustrateAI',
          //   query: {
          //     pagename: 'vocPage'
          //   }
          // })
          effectiveMeal({
            access_token: getCookie("access_token"),
          }).then((res) => {
            if (res.data.code === 0) {
              if (res.data.data.type.includes("voc")) {
                location.href = domainName.api9 + "/#/analysis";
              } else {
                this.$router.push({
                  name: "illustrateAI",
                  query: {
                    pagename: "vocPage",
                  },
                });
              }
            }
          });
        } else if (type == 3) {
          this.$router.push({
            name: "illustrateAI",
            query: {
              pagename: "servicePage",
            },
          });
        } else if (type == 4) {
          location.href = "https://yuankongai.com/";
        }
      } else {
        this.$store.commit("setLoginDisplay", true);
      }
    },
    goOpen() {
      window.open(domainName.api12);
      // this.$router.push({
      //   name: 'openPlatform',
      // })
    },
    equityComparisonPage() {
      if (getCookie("access_token")) {
        if (!getCookie("login_token")) {
          this.$store.commit("setLoginDisplay", true);
          return;
        }
        this.$router.push({
          name: "comparisonPage",
        });
      }
    },
    goBlog() {
      window.open("https://chatexcel.com/blog/");
    },
    goIntroduce() {
      window.open(domainName.api11 + "/introducepage/");
    },
    goTeaching() {
      window.open(domainName.api11 + "/aieducation/");
    },
    loginChange() {
      this.$store.commit("setLoginDisplay", true);
    },
    logOuts() {
      let that = this;
      let queryParam = JSON.parse(getCookie("queryParams"));
      this.$confirm(
        this.language == "zh_CN"
          ? zhCN.global.outlog_tips
          : this.language == "en_US"
            ? enUS.global.outlog_tips
            : "",
        this.language == "zh_CN"
          ? zhCN.global.tips
          : this.language == "en_US"
            ? enUS.global.tips
            : "",
        {
          confirmButtonText:
            this.language == "zh_CN"
              ? zhCN.global.sure_btn
              : this.language == "en_US"
                ? enUS.global.sure_btn
                : "",
          cancelButtonText:
            this.language == "zh_CN"
              ? zhCN.global.cancel
              : this.language == "en_US"
                ? enUS.global.cancel
                : "",
          type: "warning",
        }
      )
        .then(() => {
          logOut({ access_token: getCookie("access_token") }).then((res) => {
            if (res.data.code == 0) {
              clearCookies();
              that.$store.commit("setloginToken", "");
              setCookie("userInfo", "");
              that.$store.commit("setMobile", "");
              setCookie("queryParams", JSON.stringify(queryParam));
              localStorage.clear();
              location.href = domainName.api1;
            }
          });
        })
        .catch(() => { });
    },
    navigateTo(anchor) {
      // 获取当前路由的名称
      const currentRouteName = this.$route.name;

      // 如果当前路由是主页
      if (currentRouteName === "home") {
        // 滚动到指定的锚点
        const element = document.querySelector(anchor);
        if (element) {
          element.scrollIntoView({
            behavior: "smooth",
            block: "nearest",
            inline: "nearest",
          });
          // this.$router.replace({ name: 'home' })
        }
      }
      // else {
      //   // 否则导航到主页
      //   this.$router.push({ name: 'home' }).then(() => {
      //     const element = document.querySelector(anchor);
      //     if (element) {
      //       element.scrollIntoView({ behavior: 'smooth' });
      //     }
      //   });
      // }
    },
    // 去邀请好友页面
    goGiftPage() {
      this.visible = !this.visible;
      if (getCookie("access_token")) {
        if (!getCookie("login_token")) {
          this.$store.commit("setLoginDisplay", true);
          return;
        }
        this.$router.push({
          name: "inviteFriendsPage",
        });
      } else {
        this.$store.commit("setLoginDisplay", true);
      }
    },
    goBlogpage() {
      window.open('https://blog.chatexcel.com/2025/10/15/5%e6%ac%beai%e4%ba%a7%e5%93%81%ef%bc%8c%e5%8f%8c%e5%91%a8%e4%bc%9a%e5%91%98%ef%bc%8c%e5%85%8d%e8%b4%b9%e9%a2%86%ef%bc%81%e8%81%8c%e5%9c%ba%e6%95%91%e5%91%bdai%e5%b7%a5%e5%85%b7%e5%8c%85%e6%9d%a5/');

    }
  },
};
</script>

<style scoped>
.top_image {
  width: 100%;
  cursor: pointer;
}

.header {
  height: auto !important;
}

.box_div {
  height: 100%;
  padding-bottom: 30px;
}

.header .section {
  height: 80px;
}

.code_div {
  position: fixed;
  top: 280px !important;
  right: 20px;
  cursor: pointer;
}

.float_div {
  position: fixed;
  top: 200px;
  right: 20px;
  cursor: pointer;
}

.float_box {
  position: relative;
  top: -20px;
  cursor: pointer;
}

.float_box .float_bg {
  width: 180px;
  border-radius: 10px;
}

.float_box span {
  position: absolute;
  top: 0px;
  left: 32px;
  font-size: 18px;
  color: rgb(126, 98, 68);
}

.float_div .float_img_div {
  width: 50px;
  height: 50px;
  border-radius: 10px;
  box-shadow: 0px 0px 20px 0px #00000014;
  /* background: linear-gradient(
    to bottom,
    rgb(248, 148, 148),
    rgb(255, 255, 255)
  );  */
  text-align: center;
}

.float_div .float_img_div img {
  width: 50px;
  height: 50px;
  display: inline-block;
  /* margin-top: 13px; */
}

.el-dropdown {
  cursor: pointer;
}

.gift_div {
  background: linear-gradient(to right, rgb(248, 204, 166), rgb(248, 145, 67));
  display: flex;
  align-items: center;
  vertical-align: middle;
  padding: 4px 10px;
  border-radius: 20px;
  color: #fff;
  font-size: 12px;
  margin-right: 10px;
  cursor: pointer;
}

.gift_div img {
  width: 16px;
  height: 16px;
  position: relative;
  margin-right: 4px;
}

.user-card {
  position: relative;
}

.user-card .header_border {
  position: absolute;
  width: 55px;
  height: 55px;
  left: -8px;
  top: -12px;
}

.ip_judgment {
  height: 50px;
  background: #f4f4f4;
  text-align: center;
  display: flex;
  justify-content: center;
  vertical-align: middle;
  align-items: center;
  font-size: 14px;
  color: #333
}

.el-button--info {
  background: #000;
  border-radius: 20px !important
}

/* 当按钮处于悬停状态时，改变背景色和边框色 */
.el-button--info:hover {
  background-color: #202020;
  /* 悬停时的颜色 */
  border-color: #000;
}

/* 当按钮处于激活状态（按下）时，改变背景色和边框色 */
.el-button--info:active {
  background-color: #202020;
  /* 悬停时的颜色 */
  border-color: #000;
}

.w_btn {
  background: #fff;
  color: #000;
  border: none;
  border-radius: 20px !important
}

/* 当按钮处于悬停状态时，改变背景色和边框色 */
.w_btn:hover {
  background-color: #fff;
  /* 悬停时的颜色 */
  border-color: #fff !important;
  color: #000;

}

/* 当按钮处于激活状态（按下）时，改变背景色和边框色 */
.w_btn:active {
  background-color: #fff;
  /* 悬停时的颜色 */
  border-color: #fff !important;
  color: #000;

}
</style>

<style>
.el-popover.popoverStyle {
  padding: 0;
  background: none;
  box-shadow: none;
  border: none;
}

.el-popper.popoverStyles {
  background: #35ad84;
  padding: 10px 20px;
  border-radius: 16px;
  color: #fff !important;
}

.el-dropdown-menu__item:hover {
  background-color: #35ad84 !important;
  color: white !important;
}

.el-dropdown-menu__item:hover a {
  color: white !important;
}

/* 去除a标签的默认样式 */
a {
  text-decoration: none;
  list-style: none;
  line-height: 36px;
  margin: 0;
  color: #606266;
  outline: 0;
}
</style>
